import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export const generateInvoicePDF = (invoice) => {
  const doc = new jsPDF();

  const marginX = 14;
  let currentY = 20;

  // =========================
  // HEADER
  // =========================
  doc.setFontSize(20);
  doc.setFont("helvetica", "bold");
  doc.text("FACTURE", 105, currentY, { align: "center" });

  currentY += 10;

  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text(`Facture n° ${invoice.number}`, 105, currentY, { align: "center" });

  currentY += 12;

  // =========================
  // INFOS FACTURE (DROITE)
  // =========================
  doc.setFontSize(10);
  doc.text(`Date : ${new Date().toLocaleDateString()}`, 150, 20);
  doc.text(
    `Période :`,
    150,
    26
  );
  doc.text(
    `${invoice.period.from.toDate().toLocaleDateString()} → ${invoice.period.to
      .toDate()
      .toLocaleDateString()}`,
    150,
    32
  );

  // =========================
  // CLIENT / AGENT
  // =========================
  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.text(
    invoice.type === "company" ? "Entreprise facturée" : "Agent",
    marginX,
    currentY
  );

  currentY += 6;

  doc.setFontSize(11);
  doc.setFont("helvetica", "normal");
  doc.text(invoice.name, marginX, currentY);

  currentY += 10;

  // =========================
  // TABLEAU RÉCAP
  // =========================
  autoTable(doc, {
    startY: currentY,
    theme: "grid",
    head: [["Description", "Valeur"]],
    styles: {
      fontSize: 11,
      cellPadding: 6
    },
    headStyles: {
      fillColor: [245, 245, 245],
      textColor: 20,
      fontStyle: "bold"
    },
    body: [
      ["Nombre de tickets", invoice.ticketsCount],
      ["Montant total", `${invoice.totalAmount} €`]
    ]
  });

  currentY = doc.lastAutoTable.finalY + 15;

  // =========================
  // TOTAL MIS EN AVANT
  // =========================
  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text(
    `TOTAL À PAYER : ${invoice.totalAmount} €`,
    marginX,
    currentY
  );

  currentY += 10;

  // =========================
  // FOOTER
  // =========================
  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(120);
  doc.text(
    "Merci pour votre confiance.",
    105,
    285,
    { align: "center" }
  );

  // =========================
  // SAVE
  // =========================
  doc.save(`${invoice.number}.pdf`);
};
